import styled from 'styled-components';

export default styled.h1`
  text-align: center;
  font-size: 38pt;
  font-weight: 500;
  padding-top: 1.5em;
  padding-bottom: 0.75em;
  color: black;
`;
